"use strict";

$(document).ready(function () {
  if ($('#login-page').length < 1) {
    return;
  }
  var usernameInput = $('#username');
  var passwordInput = $('#password');
  var submitButton = $('#submit');
  var redirect = $('#returnurl');
  var validationLabel = $('#validation');
  if (usernameInput.length < 1 || passwordInput.length < 1 || submitButton.length < 1) {
    return;
  }
  submitButton.on('click', function (e) {
    e.preventDefault();
    validationLabel.hide();
    var redirectUrl = "/";
    if (redirect.length > 0 && redirect[0].value) {
      redirectUrl = redirect[0].value;
    }
    var username = usernameInput[0].value;
    var password = passwordInput[0].value;
    var apiUrl = "/api/sitecore/ynhxauthentication/attemptlogin?Username=" + username + "&Password=" + password;
    makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
      if (isNetworkSuccess) {
        var response = JSON.parse(xhttp.responseText);
        if (!response.Success) {
          validationLabel.show();
          validationLabel.text("Invalid username or password.");
        } else {
          window.location.href = redirectUrl;
        }
      } else {
        validationLabel.show();
        validationLabel.text("Internal error, please try again later.");
      }
    });
  });
});